/*
 * Copyright (c) 2022 SARL SIGMA POLYNESIA
 */

import { RouteObject } from 'react-router'
import CustomerEstateListPage from './CustomerEstateListPage'
import CustomerFormPage from './CustomerFormPage'
import CustomerLeaseListPage from './CustomerLeaseListPage'
import CustomerListPage from './CustomerListPage'
import CustomerMandateListPage from './CustomerMandateListPage'
import CustomerProspectingListPage from './CustomerProspectingListPage'
import CustomerReportPage from './CustomerReportPage'
import { fetchCustomer } from '../../lib/rest/customerAPIClient'
import { LoaderFunctionArgs } from 'react-router-dom'
import RouteLoaderData from '../../../../client/js/components/RouteLoaderData'

function customerLoader (args: LoaderFunctionArgs) {
  const { params } = args
  return fetchCustomer(Number(params.id))
}

export const customerRoutes: RouteObject[] = [
  {
    index: true,
    element: <CustomerListPage />
  },
  {
    path: 'create',
    element: <CustomerFormPage />
  },
  {
    path: ':id/*',
    element: <RouteLoaderData
      queryKey={['customer']}
      loader={customerLoader}
    />,
    children: [
      {
        path: 'edit',
        element: <CustomerFormPage />
      },
      {
        path: 'estates',
        element: <CustomerEstateListPage />
      },
      {
        path: 'mandates',
        element: <CustomerMandateListPage />
      },
      {
        path: 'leases',
        element: <CustomerLeaseListPage />
      },
      {
        path: 'prospecting',
        element: <CustomerProspectingListPage />
      },
      {
        path: 'reports',
        element: <CustomerReportPage />
      }
    ]
  }
]
